<template>
  <BaseFollowupRuleDialog
    apply-to-new-option
    apply-to-all-option
    :name="name"
    :rule-holder-id="profileId"
    :dialog.sync="_dialog"
    :show-details="showDetails"
    :query-rule-gql="queryRuleGql"
    :create-rule-gql="createRuleGql"
    :update-rule-gql="updateRuleGql"
    :get-query-variables="getQueryVariables"
    :is-rule-enabled="isRuleEnabled"
    :set-rule-enabled="setRuleEnabled"
    :default-rule-data="defaultRuleData"
  />
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import BaseFollowupRuleDialog from './BaseFollowupRuleDialog'
import { LIST_PROFILE_RULES, UPDATE_PROFILE_RULE, CREATE_PROFILE_RULE } from '@/backend/graphql/automationGQL'
import moment from 'moment-timezone'
import _ from 'lodash'
export default {
  name: 'ContactFollowupRuleDialog',
  components: { BaseFollowupRuleDialog },
  props: {
    name: {
      type: String,
      default: ''
    },
    dialog: {
      type: Boolean,
      default: false
    },
    showDetails: {
      type: Boolean,
      default: true
    },
    profileId: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      queryRuleGql: LIST_PROFILE_RULES,
      updateRuleGql: UPDATE_PROFILE_RULE,
      createRuleGql: CREATE_PROFILE_RULE,
      defaultRuleData: {
        name: '',
        profileId: this.profileId,
        ruleType: 'STAY_IN_CONTACT',
        enabled: true,
        repeated: true,
        applyToNew: false,
        frequency: 1,
        skipContactedWithin: 0,
        applyToBirthday: true,
        applyToAll: false,
        eventDate: moment().format('YYYY-MM-DD'),
        remindDays: -1,
        scheduleTime: '08:00 am',
        timeZone: moment.tz.guess(),
        ruleMessage: [{ body: '' }]
      }
    }
  },
  computed: {
    ...mapGetters({
      user: 'account/getUser',
      allRules: 'automation/getAllRules'
    }),
    _dialog: {
      get () {
        return this.dialog
      },
      set (val) {
        this.$emit('update:dialog', val)
      }
    }
  },
  methods: {
    ...mapActions({
      updateProfileRuleByIndex: 'automation/updateProfileRuleByIndex'
    }),
    getQueryVariables () {
      return {
        limit: 50,
        offset: 0,
        orderBy: '-id,name',
        userIds: [_.get(this.user, 'id', 0)],
        profileId: this.profileId
      }
    },
    isRuleEnabled (index) {
      const profile = _.get(this.allRules, `[${index}].profile`, [])
      return profile.filter((p) => Number(p.id) === Number(this.profileId)).length > 0
    },
    setRuleEnabled (index) {
      this.updateProfileRuleByIndex({ index, profileId: this.profileId })
    }
  }
}
</script>

<style scoped>

</style>
